import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, Button } from 'framework-ui-components/Components/V2';
import MoreVertIcon from 'framework-ui-components/Components/GoogleIcons/Outlined/MoreVertIcon';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import AzioneCambioStato from './AzioneCambioStato';
import Confirm from '../../../components/Confirm';
import StampaDichiarazioni from './StampaDichiarazioni';

const AltreAzioni = (props) => {
  const {
    servizioAttivo,
    dichiarazioniSelezionate,
    annoCampagna,
    avviaCreazioneDichiarazioneOrdinaria,
  } = props;

  const [modaleCambioStatoCompletaAperta, impostaModaleCambioStatoCompletaAperta] = useState(false);
  const [modaleCambioStatoInLavorazioneAperta, impostaModaleCambioStatoInLavorazioneAperta] = useState(false);

  return servizioAttivo
    && (
      <Fragment>
        <DropdownButton left showOpenClose={false}>
          <MoreVertIcon />
          Altre azioni
          <DropdownButton.DropdownList>
            <AzioneCambioStato
              statoDestinazione={StatoDichiarazione.InLavorazione}
              dichiarazioniSelezionate={dichiarazioniSelezionate}
              apriModaleCambioStato={() => impostaModaleCambioStatoInLavorazioneAperta(true)}
              {...props}
            />
            <AzioneCambioStato
              statoDestinazione={StatoDichiarazione.Completa}
              dichiarazioniSelezionate={dichiarazioniSelezionate}
              apriModaleCambioStato={() => impostaModaleCambioStatoCompletaAperta(true)}
              {...props}
            />
            <StampaDichiarazioni {...props} />

            {dichiarazioniSelezionate.length > 0 && (
              <Button onClick={() => avviaCreazioneDichiarazioneOrdinaria()}>
                Crea domanda {annoCampagna}
              </Button>
            )}

          </DropdownButton.DropdownList>
        </DropdownButton>
        <Confirm
          show={modaleCambioStatoInLavorazioneAperta}
          title="Conferma cambio stato"
          message={dichiarazioniSelezionate.length !== 1 ? (
            <div>
              Questa operazione sposterà le domande selezionate nello stato <b>"In lavorazione"</b>.<br />
              Vuoi cambiare gli stati?
            </div>
          ) : (
            <div>
              Questa operazione sposterà la domanda di <b>{dichiarazioniSelezionate[0].Cognome} {dichiarazioniSelezionate[0].Nome}</b> dallo stato "{StatoDichiarazione.stringify(dichiarazioniSelezionate[0].Stato)}" allo stato <b>"In lavorazione"</b>.<br />
              Vuoi cambiare lo stato?
            </div>
          )}
          primaryLabel="CAMBIA STATO"
          onSecondaryClick={() => impostaModaleCambioStatoInLavorazioneAperta(false)}
          secondaryLabel="NON CAMBIARE"
          onPrimaryClick={() => avviaImpostaStatoInLavorazione(
            filtraDichiarazioniSelezionate(
              dichiarazioniSelezionate,
              statoDestinazione,
            )
              .map((x) => x.IdDichiarazione),
          )}
        />
        <Confirm
          show={modaleCambioStatoCompletaAperta}
          title="Conferma cambio stato"
          message={dichiarazioniSelezionate.length !== 1 ? (
            <div>
              Questa operazione sposterà le domande selezionate nello stato <b>"Completa"</b>.<br />
              Vuoi cambiare gli stati?
            </div>
          ) : (
            <div>
              Questa operazione sposterà la domanda di <b>{dichiarazioniSelezionate[0].Cognome} {dichiarazioniSelezionate[0].Nome}</b> dallo stato "{StatoDichiarazione.stringify(dichiarazioniSelezionate[0].Stato)}" allo stato <b>"Completa"</b>.<br />
              Vuoi cambiare lo stato?
            </div>
          )}
          primaryLabel="CAMBIA STATO"
          onSecondaryClick={() => impostaModaleCambioStatoCompletaAperta(false)}
          secondaryLabel="NON CAMBIARE"
          onPrimaryClick={() => avviaImpostaStatoCompleta(
            filtraDichiarazioniSelezionate(
              dichiarazioniSelezionate,
              statoDestinazione,
            )
              .map((x) => x.IdDichiarazione),
          )}
        />
      </Fragment>
    );
};

AltreAzioni.propTypes = {
  servizioAttivo: PropTypes.bool.isRequired,
  dichiarazioniSelezionate: PropTypes.any.isRequired,
};

export default AltreAzioni;
